
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-a1ed3a12\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./price-disclaimer.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./price-disclaimer.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a1ed3a12\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./price-disclaimer.vue"),
  /* scopeId */
  "data-v-a1ed3a12",
  /* cssModules */
  null
)
Component.options.__file = "D:\\a\\1\\s\\CutomerAppRazorPrerender\\scripts\\src\\components\\inventory\\price-disclaimer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] price-disclaimer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a1ed3a12", Component.options)
  } else {
    hotAPI.reload("data-v-a1ed3a12", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./scripts/src/components/inventory/price-disclaimer.vue
// module id = 731
// module chunks = 0